export enum Status {
  Passed = "passed",
  Failed = "failed"
}
